"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderStyled = void 0;
const design_system_1 = require("@produits-internes-oss/design-system");
const constants_1 = require("../../theme/constants");
exports.HeaderStyled = styled.nav `
&.octo {
  min-height: 4.375em;
  max-height: 6.125em;
  border-style: solid;
  border-color: ${design_system_1.theme.colors.marine[20]};
  border-bottom-width: 0.0625em;
  background-color: ${design_system_1.theme.colors.white};

  @media (min-width: ${constants_1.sizes.tablet}) {
    height: 7vw;
    max-height: 6.125em;
  }

  @media (max-width: ${constants_1.sizes.tablet}) {
    height: auto;
    max-height: fit-content;
  }

  >.content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    max-width: 75em;
    height: 100%;
    margin: auto;

    @media (min-width: ${constants_1.sizes.tablet}) {
      flex-flow: row nowrap;
      gap: 0;
      padding: 0 1em;
    }

    @media (max-width: ${constants_1.sizes.tablet}) {
      flex-flow: column nowrap;
      gap: 1em;
      padding: 1em 0;
    }

    > button {
      height: 100%;
      cursor: pointer;

      > img {
        height: 4vw;
        min-height: 2.5em;
        max-height: 3.5em;
      }
    }

    >.shortcuts {
      display: flex;
      flex-flow: row nowrap;
      gap: 1em;
      align-items: center;
      justify-content: space-between;

      @media (min-width: ${constants_1.sizes.tablet}) {
        justify-content: space-between;
        width: auto;
        padding: 0;
      }

      @media (max-width: ${constants_1.sizes.tablet}) {
        justify-content: center;
        width: 100%;
        padding: 0 1em;
      }

      >.normal {
        > button {
          padding: 0 1em;
          border-width: 0.125em;
          border-color: transparent;

          >.text {
            @media (min-width: ${constants_1.sizes.tablet}) {
              display: initial;
            }

            @media (max-width: ${constants_1.sizes.tablet}) {
              display: none;
            }
          }

          &:hover {
            border-color: ${design_system_1.theme.colors.marine[100]};
          }
        }
      }

      >.highlight {
        > button {
          padding: 0 1em;
          border-width: 0.125em;
        }
      }

      >.separator {
        width: 0.0625em;
        height: 2em;
        background-color: ${design_system_1.theme.colors.marine[100]};

        @media (min-width: ${constants_1.sizes.tablet}) {
          display: initial;
        }

        @media (max-width: ${constants_1.sizes.tablet}) {
          display: none;
        }
      }
    }
  }
}
`;
//# sourceMappingURL=Header.styled.js.map